import { AllowedDeliveryChannel, OneTimePaymentMethodInputType, OneTimePaymentProvider, PermissionTypeDto } from "../enums";
import { DefaultWidgetGetDto } from "./company";

export interface Campaign extends Partial<DefaultWidgetGetDto> {
  id: number;
  name: string;
  description: string;
  deliveryMethod: AllowedDeliveryChannel;
  isEditing: boolean;
  videoId: string;
  useForUnified: boolean;
  campaignSettings?: CampaignSettings;
}

export interface CampaignSettings {
  id?: number;
  campaignId: number;
  notificationKey: string;
  clientId?: number;
  locationId?: number;
  isDisable: boolean;
  name: string;
  deliveryChannel: AllowedDeliveryChannel;
}

export interface CreateCustomWidgetPostDto {
  name?: string;
  description?: string;
  widgetTypeSettingId: number;
  disabled: boolean;
  disabledOnCfs: boolean;
  configured: boolean;
  deliveryMethod: AllowedDeliveryChannel;
  configuration?: string;
}

export interface UpdateCustomWidgetPutDto extends Partial<CreateCustomWidgetPostDto> {
  widgetId: number;
}

export interface LocationWithDefaultWidgetGetDto {
  icon: string;
  description: string;
  overrided: boolean;
  isOutOfThePlan: boolean;
  defaultWidgetSettings: DefaultWidgetGetDto;
  widget: WidgetGetDto;
  locationWidgetSettings: LocationWidgetSettingsGetDto;
  sortIndex?: number; // fixme: check this param: not present in API
}

export enum WidgetMode {
  Default = "Default",
  Custom = "Custom"
}

export interface WidgetGetDto {
  id: number;
  name: string;
  description: string;
  mode: WidgetMode;
}

export interface LocationWidgetSettingsGetDto {
  id: number;
  locationId: number;
  defaultWidgetSettingsId: number;
  notificationKey: string;
  disabled: boolean;
  disabledOnCfs: boolean;
  deliveryMethod: AllowedDeliveryChannel;
  configured: boolean;
  widgetSettingsJson: string;
  location?: unknown; // todo: LocationGetDto: migrate from adminUI to clearline-api
  defaultWidgetSettings: DefaultWidgetGetDto;
  landingUrl?: string; // client property only
  landingPurpose?: number; // client property only
  url?: string; // todo: check this property
  useForAllLocations?: boolean;
}

export interface WidgetSettingsGetDto {
  id: number;
  name?: string;
  icon?: string;
  description?: string;
  notificationKey: string;
  disabled: boolean;
  configured: boolean;
  deliveryMethod: AllowedDeliveryChannel;
  videoId?: string;
  isAvailableForConditions: boolean;
  isAvailableForKiosk: boolean;
  useForUnified: boolean;
  useOnCfs: boolean;
  isCustomApp: boolean; // todo: on client size only now (not implemented in API)
}

export interface OneTimePaymentMethodGetDto {
  name: string;
  imageUrl: string;
  provider: OneTimePaymentProvider;
  settings: OneTimePaymentMethodSettingsGetDto;
}

export interface OneTimePaymentMethodSettingsGetDto {
  inputs: OneTimePaymentInputGetDto[];
}

export interface OneTimePaymentInputGetDto {
  example: string;
  inputType: OneTimePaymentMethodInputType;
  permission: PermissionTypeDto;
  isPromo: boolean; // client property
}
